import { render, staticRenderFns } from "./tempPengiraanKUPSSPA.vue?vue&type=template&id=836fa536&scoped=true&"
import script from "./tempPengiraanKUPSSPA.vue?vue&type=script&lang=js&"
export * from "./tempPengiraanKUPSSPA.vue?vue&type=script&lang=js&"
import style0 from "./tempPengiraanKUPSSPA.vue?vue&type=style&index=0&id=836fa536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836fa536",
  null
  
)

export default component.exports